module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-photo-a24e982a7822a4662ff26f4f96b5c74e.svg";